

import { mapGetters, mapActions } from 'vuex';

// SOPHEOS
import { removeWhitespaces } from '@sopheos/orbjs_rules';

// MIXINS
import errorsMixin from '../mixins/error-handler';

// API
import * as apiReport from '../api/private/report';

export default {
  name: 'SDetailContributors',
  mixins: [errorsMixin],
  props: {
    contributors: {
      type: Array,
      default: () => [],
    },
    container: {
      type: String,
      required: true,
    },
    openContributorsReport: {
      type: Boolean,
      default: false,
    },
    errorContributors: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      displayAll: false,
      itemsPerRow: 0,
      hasRows: false,
      contributorsList: [],
      // REPORT
      waitClose: false,
      showReportForm: false,
      reportFormBtn: {
        closeText: 'Annuler',
        confirmText: 'Valider',
      },
      reportFormOptions: { width: '500' },
      reportFormTitle: 'Signalement',
      reportFormLabel: 'Fenêtre de signalement',
      reportFormLoading: false,
      reportMessage: null,
      reportTarget: null,
      waitReport: false,
    };
  },
  computed: {
    ...mapGetters({
      getUser: 'preferences/getUser',
      isAuth: 'authToken/isAuth',
      getWindowHeight: 'screen/getWindowHeight',
      getWindowWidth: 'screen/getWindowWidth',
    }),
    reportMessageIsSet() {
      // The message is not null and is not empty
      return this.reportMessage?.length > 0;
    },
    reportMessageIsValid() {
      // The message is set and contains between 10 and 400 characters
      return this.reportMessageIsSet && this.reportMessage.length >= 10 && this.reportMessage.length <= 400;
    },
    getWindowSize() {
      return `${this.getWindowHeight} - ${this.getWindowWidth}`;
    },
  },
  watch: {
    contributors: {
      immediate: true,
      handler() {
        this.contributorsList = this.contributors.map((contributor) => ({ ...contributor, tooltip: false, hidden: true }));
        if (this.contributorsList.length) {
          this.checkNumberOfRows();
        }
      },
    },
    getWindowSize() {
      if (this.contributorsList.length) {
        this.checkNumberOfRows();
      }
    },
    displayAll() {
      const list = this.$refs.contributorsList;
      const height = this.displayAll ? list.scrollHeight : 58;
      this.$refs.contributorsList.style.height = `${height}px`;
      this.contributorsList.forEach((contributor, index) => {
        if (this.displayAll) {
          setTimeout(() => {
            contributor.hidden = false;
          }, 250);
        } else if (index + 1 > this.itemsPerRow) {
          contributor.tooltip = false;
          contributor.hidden = true;
        }
      });
    },
    openContributorsReport(value) {
      if (value && this.waitReport) {
        this.waitReport = false;
        this.openReport(this.reportTarget);
      }
    },
    reportMessage() {
      // When the message changes, if it is not set or if it is valid, set the error to false
      if (!this.reportMessageIsSet || this.reportMessageIsValid) {
        this.errors$.handleError(false, 'reports', 'message');
      }
    },
  },
  methods: {
    ...mapActions({
      initSnackbar: 'snackbar/initSnackbar',
    }),
    async checkNumberOfRows() {
      this.displayAll = false;
      if (process.client) {
        await this.$nextTick();
        const list = this.$refs.contributorsList;
        if (list) {
          await this.$nextTick();
          const item = this.$refs.contributorItems[0].$el;
          this.itemsPerRow = Math.floor(list.clientWidth / item.clientWidth);
          this.hasRows = this.contributorsList.length > this.itemsPerRow;
          this.contributorsList.forEach((contributor, index) => {
            if (index + 1 > this.itemsPerRow) {
              contributor.hidden = true;
            } else if (contributor.hidden) {
              contributor.hidden = false;
            }
          });
        }
      }
    },
    // REPORT ------------------------------------------------------------------------------------------
    openReport(target) {
      if (target) {
        this.reportTarget = target;

        // The user can't report his own profile
        if (this.isAuth && this.getUser.alias === this.reportTarget) {
          this.errors$.handleError(true, 'reports', 'alias', 'report_yourself');
          this.displayInfoSnackbar(this.errors$.get('reports', 'alias'), 'error');
          this.closeReport();
          return;
        }
      }
      if (!this.isAuth) {
        this.waitReport = true;
        this.$emit('login');
        return;
      }
      this.showReportForm = true;
    },
    closeReport() {
      this.waitReport = false;
      this.reportMessage = null;
      this.reportTarget = null;
      this.showReportForm = false;
      this.errors$.reset();
    },
    sendReport() {
      this.reportMessage = removeWhitespaces(this.reportMessage);

      // prevalidation
      this.errors$.reset();
      this.errors$.handleError(this.reportMessageIsSet && !this.reportMessageIsValid, 'reports', 'message');
      if (this.errors$.hasErrors()) {
        this.errors$.focusFirstError();
        return;
      }

      const data = {
        context: 'profile',
        playground: this.playgroundId,
        message: this.reportMessage,
        alias: this.reportTarget,
      };

      this.reportFormLoading = true;
      apiReport.report(data, this).then(() => {
        this.closeReport();
        const snackbar = {
          options: {
            color: 'success',
          },
          content: 'Votre signalement a été pris en compte',
        };
        this.initSnackbar(snackbar);
      }).catch((error) => {
        // Validation error
        if (error.response && (error.response.status === 400 || error.response.status === 404)) {
          this.errors$.handleError(true, 'reports', 'alias', 'default');
        }
      }).finally(() => {
        this.reportFormLoading = false;
      });
    },
    displayInfoSnackbar(content, color) {
      const snackbar = {
        options: {
          color,
        },
        content,
      };
      this.initSnackbar(snackbar);
    },
  },
};
